<template>
  <svg
    version="1.1"
    id="레이어_2_1_"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 56.3 80.3"
    style="enable-background:new 0 0 56.3 80.3;"
    xml:space="preserve"
  >
    <path class="st0" d="M17,14.8" />
    <path
      class="st1"
      d="M42.7,11.1H13.5c-1.1,0-2-0.9-2-2s0.9-2,2-2h29.2c1.1,0,2,0.9,2,2S43.8,11.1,42.7,11.1z"
    />
    <path
      class="st1"
      d="M42.7,11.1c-0.6,0-1.1-0.2-1.5-0.6l-6.6-7.2c-0.7-0.8-0.6-2.1,0.2-2.8c0.8-0.7,2-0.6,2.7,0.1l6.6,7.2
	c0.8,0.8,0.8,2.1,0,2.8c0,0,0,0,0,0C43.7,11,43.2,11.1,42.7,11.1z"
    />
    <path
      class="st1"
      d="M36.1,18.3c-1.1,0-2-0.9-2-2c0-0.5,0.2-1,0.5-1.4l6.6-7.2c0.8-0.8,2-0.9,2.8-0.1c0.8,0.8,0.9,2,0.1,2.8
	l-6.6,7.2C37.2,18.1,36.7,18.3,36.1,18.3z"
    />
    <path
      class="st1"
      d="M28.1,80.3C12.6,80.3,0,67.7,0,52.1S12.6,24,28.1,24c15.5,0,28.1,12.6,28.1,28.1C56.2,67.7,43.6,80.2,28.1,80.3
	z M28.1,28C14.8,28,4,38.8,4,52.1s10.8,24.1,24.1,24.1s24.1-10.8,24.1-24.1c0,0,0,0,0,0C52.2,38.8,41.4,28,28.1,28z"
    />
    <path
      class="st1"
      d="M34.5,47.2c-1.6-1.5-3.7-2.3-5.9-2.3c-2.3,0-3.9,0.9-3.9,2.7c0,3.9,12.4,2.5,12.4,10.2c0,3.6-2.5,6.2-7,6.8v4.1
	h-3v-4c-2.8-0.2-5.5-1.3-7.7-3.1l2.1-3.1c1.8,1.6,4.2,2.5,6.7,2.5c3.2,0,4.6-1,4.6-2.8c0-4.1-12.4-2.8-12.4-10.3
	c0-3.7,2.6-6.2,6.7-6.7v-4H30v4c2.5,0.3,4.9,1.5,6.7,3.2L34.5,47.2z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SendIcon',
};
</script>

<style scoped>
.st0 {
  fill: #121212;
  stroke: #000000;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.st1 {
  fill: #121212;
}
</style>
